/* ============================================================
   ROSY NAILS — Product card image switch (desktop hover)
   Adds .is-rosy-hover to a card's image while the mouse is
   over that image, and removes it when the mouse leaves.
   Styling / fade lives in assets/rosy-card-image-swap.css.
   Mobile swipe is pure CSS (no JS needed).
   ============================================================ */
(function () {
  'use strict';
  if (window.__rosyCardImageSwap) return;
  window.__rosyCardImageSwap = true;
  if (!window.matchMedia) return;

  var desktop = window.matchMedia('(hover: hover) and (pointer: fine)');
  var active = null;

  function setActive(el) {
    if (active === el) return;
    if (active) active.classList.remove('is-rosy-hover');
    active = el;
    if (el) el.classList.add('is-rosy-hover');
  }

  document.addEventListener(
    'pointermove',
    function (e) {
      if (!desktop.matches || e.pointerType === 'touch') return;
      var target = e.target;
      var wrap = target && target.closest ? target.closest('.card-wrapper') : null;
      var media = wrap ? wrap.querySelector('.card__media .media.rosy-card-swap') : null;
      if (!media) {
        setActive(null);
        return;
      }
      var r = media.getBoundingClientRect();
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      setActive(inside ? media : null);
    },
    { passive: true }
  );

  document.documentElement.addEventListener('mouseleave', function () {
    setActive(null);
  });
  window.addEventListener(
    'scroll',
    function () {
      setActive(null);
    },
    { passive: true }
  );
  window.addEventListener('blur', function () {
    setActive(null);
  });
})();
